import React, { createContext, useState } from "react"
const userData = JSON.parse(localStorage.getItem("user"))

export const UserContext = createContext()

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({ ...userData });
  return (
    <UserContext.Provider value={{user, setUser}}>
      {children}
    </UserContext.Provider>
  );
};